import { render, staticRenderFns } from "./AHAudioEdit.vue?vue&type=template&id=3ab93dff&"
import script from "./AHAudioEdit.vue?vue&type=script&lang=ts&"
export * from "./AHAudioEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports